var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "instagram",
    transform: "translate(0 -0.4)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_320",
    "data-name": "Ellipse 320",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(0 0.4)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_103",
    "data-name": "Union 103",
    d: "M12460.971,17296a6.979,6.979,0,0,1-6.971-6.971v-10.057a6.98,6.98,0,0,1,6.971-6.973h10.058a6.98,6.98,0,0,1,6.972,6.973v10.057a6.979,6.979,0,0,1-6.972,6.971Zm-5.1-17.027v10.057a5.1,5.1,0,0,0,5.1,5.1h10.058a5.1,5.1,0,0,0,5.1-5.1v-10.057a5.106,5.106,0,0,0-5.1-5.1h-10.058A5.105,5.105,0,0,0,12455.875,17278.973Zm3.2,5.025a6.926,6.926,0,1,1,6.928,6.928A6.936,6.936,0,0,1,12459.074,17284Zm2.01,0a4.918,4.918,0,1,0,4.918-4.918A4.922,4.922,0,0,0,12461.084,17284Zm10.557-6.355a1,1,0,1,1,1,1A1,1,0,0,1,12471.641,17277.643Z",
    transform: "translate(-12442 -17259.6)",
    fill: "#feffff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.75f6065e780653da0bbb29af6c4a53db.svg";
export { ForwardRef as ReactComponent };